var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      class: [
        "playground padding-top-5xl padding-bottom-2xl",
        { inverted: _vm.previewMode == "night" },
      ],
      style: _vm.componentStyle,
      attrs: { id: "icon-pack-playground" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "playground-wrapper display-flex flex-content-center",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "playground-icons display-flex flex-row flex-nowrap flex-items-end flex-content-center",
                staticStyle: {
                  gap: "var(--icon-pack-playground-spacing, 5%)",
                  "font-size":
                    "var(--icon-pack-playground-size, var(--_icon-pack-playground-size))",
                },
              },
              _vm._l(_vm.featuredIcons, function (icon, index) {
                return _c(
                  "span",
                  {
                    key: `${icon}-${index}-${_vm.offset}`,
                    staticClass: "playground-icon-container",
                  },
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: "plaground-icon-update",
                          "enter-active-class":
                            "animate__animated animate__faster animate__bounceIn",
                          appear: "",
                        },
                      },
                      [
                        _c("i", {
                          class: [
                            `${_vm.familyStyleByIndex(index)} fa-${icon} ${
                              _vm.animationStyle
                            } fa-fw playground-icon`,
                          ],
                          style: `font-size: var(--icon-pack-playground-size, calc(${_vm.selectedSize} * 1em));`,
                        }),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "playground-controls margin-top-4xl",
            style: `
        --button-background: none;
        --button-font-weight: var(--font-weight-normal);
        --button-hover-background: none;
        --button-hover-background: var(--theme-button-hover-background);
        --button-hover-border-color: var(--theme-button-hover-border-color);
        --button-margin-bottom: 0;
        --button-padding: var(--spacing-sm) var(--spacing-md);
        --form-button-margin: 0;
        --input-background: transparent;
        --input-border-color: var(--border-color);
        --input-border-radius: var(--button-border-radius);
        --input-min-height: 3.25em;
        --input-with-icon-color: initial;
        --label-color: initial;
        --label-font-weight: var(--font-weight-normal);
        --link-color: initial;
      `,
          },
          [
            _c(
              "form",
              {
                staticClass:
                  "display-flex flex-items-center flex-content-center flex-wrap",
                staticStyle: { gap: "var(--spacing-xl)" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "display-flex flex-items-center playground-control-size padding-y-sm padding-x-md with-border",
                    staticStyle: {
                      "border-radius": "var(--border-radius-sm)",
                      gap: "var(--spacing-sm)",
                    },
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "text-nowrap margin-0",
                        attrs: { for: "playground-control-size-input" },
                      },
                      [_vm._v("Icon Size")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.size,
                          expression: "size",
                        },
                      ],
                      staticStyle: { width: "auto" },
                      attrs: {
                        id: "playground-control-size-input",
                        list: "playground-control-size",
                        max: "6",
                        min: "0",
                        type: "range",
                        value: "4",
                      },
                      domProps: { value: _vm.size },
                      on: {
                        __r: function ($event) {
                          _vm.size = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("wa-select-custom", {
                  staticClass: "playground-control-animation",
                  attrs: {
                    "custom-select-style": _vm.selectCustomSelectStyle,
                    "is-full-width": false,
                    options: _vm.animationOptions,
                    value: _vm.animation,
                    "icon-name": "faSwatchbook",
                    "is-minimal": "",
                    label: "Animation",
                  },
                  on: { change: (value) => _vm.updateAnimation(value) },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "flat with-border playground-control-swap-icons",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.swapIcons()
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "margin-right-3xs",
                      attrs: {
                        icon: _vm.$v6.solid.faSwap,
                        size: "lg",
                        "fixed-width": "",
                      },
                    }),
                    _vm._v("\n          Swap Icons\n        "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "flat with-border playground-control-shuffle-styles",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.shuffleStyles()
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "margin-right-3xs",
                      attrs: {
                        icon: _vm.$v6.solid.faShuffle,
                        size: "lg",
                        "fixed-width": "",
                      },
                    }),
                    _vm._v("\n          Shuffle Styles\n        "),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.previewMode === "day"
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "flat with-border playground-control-invert",
                        attrs: {
                          "aria-label": "Nox!",
                          "data-balloon-pos": "up",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.togglePreviewMode("night")
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faMoon,
                            size: "lg",
                            "fixed-width": "",
                          },
                        }),
                        _vm._v("\n          Invert\n        "),
                      ],
                      1
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "flat with-border playground-control-invert",
                        attrs: {
                          "aria-label": "Lumos!",
                          "data-balloon-pos": "up",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.togglePreviewMode("day")
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faSun,
                            size: "lg",
                            "fixed-width": "",
                          },
                        }),
                        _vm._v("\n          Invert\n        "),
                      ],
                      1
                    ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }